/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Events {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { Section } from "@bw/bits"
import { Events as EventsModule } from "./Events"
import { useStaticQuery, graphql } from "gatsby"
import Event from "../../../models/event"

const Events = ({ subtitle, title, suptitle, anchor }) => {
  const { events } = useStaticQuery(graphql`
    query eventsModulesQuery {
      events: allCollectionEvents(sort: { startDate: DESC }) {
        nodes {
          title
          slug
          startDate
          startTime
          teaserExcerpt
          teaserImage {
            localImage {
              childImageSharp {
                gatsbyImageData(width: 350, height: 175)
              }
            }
          }
        }
      }
    }
  `)

  if (!events.nodes) {
    return null
  }

  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        anchor,
        //button,
        //buttonPosition: buttonPosition?.value,
      }}
    >
      <EventsModule events={events.nodes.map(event => new Event(event))} />
    </Section>
  )
}

export { Events }
